import React from 'react';
import { A, useQueryParams } from 'hookrouter';
import '../styles/pages/error.scss';
import { useTranslation } from 'react-i18next';
import { GENERAL_ERROR_MESSAGE, PAGE_MISSING_MESSAGE, BACK_TO_HOME_MESSAGE, AUTH_ERROR_MESSAGE } from '../i18n/keyConstants';


const ErrorPage = ({ error }) => {
    const env = process.env.NODE_ENV;
    const [queryParams] = useQueryParams();
    const { t } = useTranslation('errorMessages');

    if (queryParams && queryParams.status === 401) {
        return (
            <div className='error-page text-center'>
                <span>{queryParams.status}</span>
                <p>{t(AUTH_ERROR_MESSAGE)}</p>
                <A href='/'>{t(BACK_TO_HOME_MESSAGE)}</A>
            </div>
        );
    } else if (env === 'production') {
        return (
            <div className='error-page text-center'>
                <span>{error && error.status ? error.status : '404'}</span>
                <h1>{t(GENERAL_ERROR_MESSAGE)}</h1>
                <p>{t(PAGE_MISSING_MESSAGE)}</p>
                <A href='/'>{t(BACK_TO_HOME_MESSAGE)}</A>
            </div>
        );
    } else {
        return (
            <div className='error-page text-center'>
                <span>{error && error.status ? error.status : '404'}</span>
                <h1>{error && error.statusText}</h1>
                <p>{error && error.data.error}</p>
            </div>
        );
    }
};

export default ErrorPage;
